export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA2154-1.e3ac6873.jpg";